// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "cc.localtrade.lab",
    name: "LocalTrade Wallet",
    homepage: "https://lab.localtrade.cc",
    image_id: "fcc60983-74ae-484a-4242-87cb6f05f100",
    app: {
        browser: "https://docs.localtrade.cc/products/defi-wallet-mvp-for-ios",
        ios: "https://apps.apple.com/app/localtrade-defi-wallet/id1602772298",
        android: "https://play.google.com/store/apps/details?id=com.localtrade.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://ws.lab.localtrade.cc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map